import { Paper, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const SectionDivider = ({ title, sx = {} }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: '#f5f5f5',
        borderRadius: 1,
        p: 1.5,
        mb: 2,
        ...sx,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 'bold',
          color: 'text.secondary',
        }}
      >
        {title}
      </Typography>
    </Paper>
  )
}

SectionDivider.propTypes = {
  title: PropTypes.string,
  sx: PropTypes.object,
}

export default SectionDivider
